module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_100_250.3684bcdb.png";